import React, { useMemo } from 'react';

import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Card,
  CardBody,
  Button
} from 'reactstrap';

import Select from 'react-select';

import FieldError from "../../../../../../helper/FieldError";

const WorkflowHttpRequestBodyResponseContentItemForm = props => {
  const {
    currentNode,
    bodyResponseContentItem,
    callbacks: {
      onChangeBodyResponseContentItem: callbackOnChangeBodyResponseContentItem,
      onRemoveBodyResponseContentItem: callbackOnRemoveBodyResponseContentItem,
      activeOutputStageFileItems
    }
  } = props;

  const errorKey = (key) => {
    return `data.errors.body_response_content_${bodyResponseContentItem.custom_id}_${key}`
  }

  // ---------- START KEY INPUT ----------
  const keyInput = () => {
    return(
      <FormGroup>
        <FieldError errors={ _.get(currentNode, errorKey('key')) }>
          <Label>Key</Label>
          <Input
            type="text"
            name="key"
            value={ bodyResponseContentItem?.key }
            invalid={ _.has(currentNode, errorKey('key')) }
            onChange={ event => callbackOnChangeBodyResponseContentItem(event, bodyResponseContentItem.custom_id) }
          />
        </FieldError>
      </FormGroup>
    )
  }
  // ---------- END KEY INPUT ----------
  // ----------------------------------------
  // ---------- START DATA TYPE SELECT INPUT ----------
  const dataTypeSelectOptions = [
    // { value: 'text', label: 'Text' },
    // { value: 'number', label: 'Number' },
    // { value: 'boolean', label: 'Boolean' },
    // { value: 'array', label: 'Array' },
    // { value: 'object', label: 'Object' },
    { value: 'Base64', label: 'Base64' },
  ]

  const dataTypeSelectedOption = useMemo(() => {
    return dataTypeSelectOptions.find(option => option.value === bodyResponseContentItem?.data_type)
  }, [bodyResponseContentItem?.data_type])

  const dataTypeSeletInput = () => {
    return(
      <FormGroup>
        <FieldError errors={ _.get(currentNode, errorKey('data_type')) }>
          <Label>Data Type</Label>
          <Select
            options={ dataTypeSelectOptions }
            value={ dataTypeSelectedOption }
            invalid={ _.has(currentNode, errorKey('data_type')) }
            onChange={ e => callbackOnChangeBodyResponseContentItem({ target: { name: 'data_type', value: e.value } }, bodyResponseContentItem.custom_id) }
          />
        </FieldError>
      </FormGroup>
    )
  }
  // ---------- END DATA TYPE SELECT INPUT ----------
  // ----------------------------------------
  // ---------- START CONTENT TYPE FILE SELECT INPUT ----------
  const contentTypeFileSelectOptions = [
    {label: "pdf", value: "application/pdf"},
    {label: "doc", value: "application/msword"},
    {label: "docx", value: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"},
    {label: "xlsx", value: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"},
    {label: "xls", value: "application/vnd.ms-excel"},
    {label: "jpeg", value: "image/jpeg"},
    {label: "jpg", value: "image/jpeg"},
    {label: "png", value: "image/png"}
  ]

  const contentTypeFileSelectedOption = useMemo(() => {
    return contentTypeFileSelectOptions.find(option => option.value === bodyResponseContentItem?.content_type_file)
  }, [bodyResponseContentItem?.content_type_file])

  const contentTypeFileSelectInput = () => {
    if(bodyResponseContentItem?.data_type === 'Base64') {
      return(
        <FormGroup>
          <FieldError errors={ _.get(currentNode, errorKey('content_type_file')) }>
            <Label>Content Type File</Label>
            <Select
              options={ contentTypeFileSelectOptions }
              value={ contentTypeFileSelectedOption }
              invalid={ _.has(currentNode, errorKey('content_type_file')) }
              onChange={ e => callbackOnChangeBodyResponseContentItem({ target: { name: 'content_type_file', value: e.value } }, bodyResponseContentItem.custom_id) }
            />
          </FieldError>
        </FormGroup>
      )
    }
  }
  // ---------- END CONTENT TYPE FILE SELECT INPUT ----------
  // ----------------------------------------
  // ---------- START OUTPUT FILE SELECT INPUT ----------
  const outputAssociatedSelectOptions = useMemo(() => {
    let options = []

    if(bodyResponseContentItem.data_type === 'Base64') {
      if(_.isArray(activeOutputStageFileItems) && activeOutputStageFileItems.length > 0) {
        options = _.map(activeOutputStageFileItems, item => {
          return {
            label: item.name,
            value: `$current_stage-${ currentNode?.data?.id }.output_file_item-${ item?.custom_id }$`
          }
        })
      }
    }

    return options;
  }, [activeOutputStageFileItems, bodyResponseContentItem.data_type])

  const outputAssociatedSelectedOption = useMemo(() => {
    return outputAssociatedSelectOptions.find(option => option.value === bodyResponseContentItem?.output_associated)
  }, [bodyResponseContentItem?.output_associated, outputAssociatedSelectOptions])

  const outputAssociatedSelectInput = () => {
    return(
      <FormGroup>
        <FieldError errors={ _.get(currentNode, errorKey('output_associated')) }>
          <Label>Output Associated</Label>
          <Select
            options={ outputAssociatedSelectOptions }
            value={ outputAssociatedSelectedOption }
            invalid={ _.has(currentNode, errorKey('output_associated')) }
            onChange={ e => callbackOnChangeBodyResponseContentItem({ target: { name: 'output_associated', value: e.value } }, bodyResponseContentItem.custom_id) }
          />
        </FieldError>
      </FormGroup>
    )
  }
  // ---------- END OUTPUT FILE SELECT INPUT ----------
  // ----------------------------------------
  // ---------- START REMOVE BUTTON ----------
  const removeButton = () => {
    return(
      <div className='text-end'>
        <Button
          outline
          color='danger'
          size='sm'
          onClick={ () => callbackOnRemoveBodyResponseContentItem(bodyResponseContentItem.custom_id) }
        >
          <i className='fas fa-trash'></i>&nbsp;
          { I18n.t('actions.destroy') }
        </Button>
      </div>
    )
  }
  // ---------- END REMOVE BUTTON ----------

  return (
    <Row>
      <Col md={ 12 }>
        <Card>
          <CardBody>
            { keyInput() }
            { dataTypeSeletInput() }
            { contentTypeFileSelectInput() }
            { outputAssociatedSelectInput() }
            { removeButton() }
          </CardBody>
        </Card>
      </Col>
    </Row>
  )
}

export default WorkflowHttpRequestBodyResponseContentItemForm;
